import fetch from '@/api/index';
export default {
  namespaced: true,
  state: {
    addressInfo: {},
    addId: undefined,
    location: undefined
  },
  mutations: {
    setAddressInfo(state, val) {
      state.addressInfo = val;
    },
    setAddId(state, val) {
      state.addId = val;
    },
    setLocation(state, city) {
      state.location = city || '';
    }
  }
};
